import type { BusSeatPreference, BusSeatsSource } from '@voll-intelligence/intelligence-ui-kit';
import { useGenUiConfig } from '../../shared/ui/config.js';

/**
 * A planta da viagem de ônibus para a escolha de poltrona do card de partidas
 * (`POST /bus/seats` no web-chat) — leitura idempotente, como os ports do voo.
 */
export interface BusSeatsPort {
  /** Um mapa por trecho; trecho ausente = sem marcação de assento nele.
   *  Rejeição = falha recuperável: "tentar novamente" ou "seguir sem assento".
   *  Um `BusSeatsError` diz o motivo (conexão ou fornecedor); outra rejeição
   *  é o fornecedor. */
  getSeats: (offerId: string) => Promise<BusSeatsSource>;
  /** As Preferências de ônibus que sugerem a poltrona; `null` = sem
   *  preferência. Ausente ⇒ sem sugestão. */
  getSeatPreference?: () => Promise<BusSeatPreference | null>;
}

export function useBusSeatsPort(): BusSeatsPort | null {
  return useGenUiConfig().ports?.busSeats ?? null;
}
